import { Box, Card, Grid, Typography } from '@mui/material';
import { GoBackButtonWithIcon } from '../buttons/GoBackButtonWithIcon';

interface Props {
  children: React.ReactNode;
  size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  cardHeaderText?: string;
  showGoBackButton?: boolean;
}

const DefaultCard: React.FC<Props> = ({ children, cardHeaderText, showGoBackButton, size = 7 }) => (
  <Grid item xs={12} md={size}>
    <Card sx={{ p: 3, overflow: 'visible' }}>
      <Box
        sx={{
          display: 'grid',
          gap: 1,
          gridTemplateColumns: { xs: '7fr 1fr' },
        }}
      >
        <Typography variant="h6">{cardHeaderText}</Typography>
        {showGoBackButton ? <GoBackButtonWithIcon /> : <> </>}
      </Box>
      {children}
    </Card>
  </Grid>
);

export default DefaultCard;
